import Swiper, {Navigation, Thumbs, Autoplay} from 'swiper';

export default () => {

	let gallery = {
		init: function () {

			document.querySelectorAll('.js--gallery').forEach((component) => {

				const $gallery = component.querySelector('.gallery__gallery'),
					$thumbs = component.querySelector('.gallery__gallery-thumbs');

				let slidesPerView = 1;
				let items = component.dataset.items;
				if (items) slidesPerView = items;
				let slidesPerViewTablet = slidesPerView;
				let itemsTablet = component.dataset.itemsTablet;
				if (itemsTablet) slidesPerViewTablet = itemsTablet;
				let slidesPerViewDesktop = slidesPerViewTablet;
				let itemsDesktop = component.dataset.itemsDesktop;
				if (itemsDesktop) slidesPerViewDesktop = itemsDesktop;

				let loop = false;
				let dataLoop = component.dataset.loop;
				if (dataLoop !== undefined) loop = true;
				let loopTablet = loop;
				let dataLoopTablet = component.dataset.loopTablet;
				if (dataLoopTablet === 'true') loopTablet = true;
				else if (dataLoopTablet === 'false') loopTablet = false;

				let allowTouchMove = true;
				let dataAllowTouchMove = component.dataset.allowtouchmove;
				if (dataAllowTouchMove === 'false') allowTouchMove = false;

				let autoplay = false;
				let dataAutoplay = component.dataset.autoplay;
				if (dataAutoplay !== undefined) {
					autoplay = {
						delay: Number(dataAutoplay),
						disableOnInteraction: false
					};
				}

				if (component.classList.contains('_gallery-init')) {

					$gallery.swiper.update();

				} else {

					let galleryWidth = $gallery.clientWidth;
					let thumbWidth = $thumbs.querySelector(".gallery__thumb").clientWidth;
					let thumbsCount = $thumbs.querySelectorAll(".gallery__thumb").length;

					let swiper = new Swiper($thumbs, {
						wrapperClass: 'gallery__thumbs',
						slideClass: 'gallery__thumb',
						loop: thumbWidth * thumbsCount < galleryWidth ? false : loop,
						slidesPerView: "auto",
						watchSlidesProgress: true,
						spaceBetween: 12,
						breakpoints: {
							767: {
								spaceBetween: 16,
							}
						},
					})

					new Swiper($gallery, {
						modules: [Navigation, Thumbs, Autoplay],
						allowTouchMove: allowTouchMove,
						wrapperClass: 'gallery__slides',
						slideClass: 'gallery__slide',
						speed: 1000,
						loop: thumbsCount > 1 ? loop : false,
						autoplay: autoplay,
						slidesPerView: slidesPerView,
						preloadImages: false,
						watchOverflow: true,
						//autoHeight: true,
						navigation: {
							nextEl: component.querySelector('.js--gallery-next'),
							prevEl: component.querySelector('.js--gallery-prev')
						},
						thumbs: {
							swiper: swiper,
						}
					});

					if (thumbsCount < 2){
						$thumbs.remove();
					}

					component.classList.add('_gallery-init');

				}

			});

		}
	}
	gallery.init();

}